import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useState } from 'react';

import { TableSection } from '../styles';
import { OperationFlow } from './components/OperationFlow';
import { RequestList } from './components/RequestList';
import { RequestView } from './types';

export function NoticeDetailsRequest(): JSX.Element {
  const [view, setView] = useState<RequestView>('list');

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: RequestView | null
  ): void => {
    if (newView) setView(newView);
  };

  return (
    <TableSection>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Pedidos de credenciamento
      </Typography>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        size="small"
        color="secondary"
        sx={{ mb: 2 }}
      >
        <ToggleButton value="list" sx={{ textTransform: 'none' }}>
          Lista
        </ToggleButton>
        <ToggleButton value="operation-flow" sx={{ textTransform: 'none' }}>
          Fluxo de Operação
        </ToggleButton>
      </ToggleButtonGroup>
      {view === 'list' ? <RequestList /> : <OperationFlow />}
    </TableSection>
  );
}
